import { Link, useLocation } from 'react-router-dom';
import { Settings, Building2, BookOpen, ArrowRight, ChevronDown, FileText, Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const Header = () => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isVendorPage = location.pathname.startsWith('/vendor');
  const isVendorsInfoPage = location.pathname === '/vendors';
  const isLandingPage = location.pathname === '/';
  const isGuidePage = location.pathname === '/guide';
  const isLearnPage = location.pathname === '/learn';
  const isBlogPage = location.pathname.startsWith('/blog');
  const isAboutPage = location.pathname === '/about';

  return (
    <header className="w-full border-b border-border bg-card/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <img 
              src="/logo-square.png" 
              alt="GoCompareAI" 
              className="h-8 w-8 sm:h-10 sm:w-10 rounded-lg"
            />
            <span className="font-semibold text-foreground text-sm sm:text-base">GoCompareAI</span>
          </Link>

          {/* Right side */}
          <nav className="flex items-center gap-2 sm:gap-4">
            {/* Resources dropdown - show on landing, guide, learn, blog, about pages */}
            {(isLandingPage || isGuidePage || isLearnPage || isBlogPage || isAboutPage) && (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="sm" className="gap-1.5 text-muted-foreground hover:text-foreground">
                    <BookOpen className="w-4 h-4" />
                    <span className="hidden sm:inline">Resources</span>
                    <ChevronDown className="w-3 h-3" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-48">
                  <DropdownMenuItem asChild>
                    <Link to="/about" className="flex items-center gap-2 cursor-pointer">
                      <Info className="w-4 h-4" />
                      About Us
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem asChild>
                    <Link to="/learn" className="flex items-center gap-2 cursor-pointer">
                      <BookOpen className="w-4 h-4" />
                      Learn about AI
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem asChild>
                    <Link to="/blog" className="flex items-center gap-2 cursor-pointer">
                      <FileText className="w-4 h-4" />
                      Read our Blog
                    </Link>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            )}
            
            {/* Show Vendors & Admin button on landing page */}
            {isLandingPage && (
              <Button size="sm" asChild className="gap-1.5">
                <Link to="/vendors">
                  Vendors & Admin
                  <ArrowRight className="w-3 h-3" />
                </Link>
              </Button>
            )}
            
            {/* Show Vendors link except on vendor pages */}
            {!isVendorPage && !isVendorsInfoPage && !isLandingPage && (
              <Button variant="ghost" size="sm" asChild>
                <Link to="/vendors" className="gap-1.5">
                  <Building2 className="w-4 h-4" />
                  <span className="hidden sm:inline">Vendors</span>
                </Link>
              </Button>
            )}
            
            {/* Show Admin link except on admin page and landing */}
            {!isAdminPage && !isLandingPage && (
              <Button variant="ghost" size="sm" asChild>
                <Link to="/admin" className="gap-1.5">
                  <Settings className="w-4 h-4" />
                  <span className="hidden sm:inline">Admin</span>
                </Link>
              </Button>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};
